import {
  Typography,
  Input,
  InputAdornment,
} from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';

export const StyledHeading = styled(Typography)`
  font-weight: bold;
  font-size: 20px;
  line-height: 47px;
  color: #3D454B;
  text-align:center;
`;

export const StyledGrayText = styled(Typography)`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #9E9E9E;
  margin-top:10px;
`;

export const StyledErrorText = styled(Typography)`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: red;
  margin-top:10px;
`;

export const StyledIcon = styled(InputAdornment)`
margin-right:19px;
`;

export const StyledInput = styled(Input)`
  background-color:#f8fafb;
  border-radius:4px;
  width:100%;
  padding:11px 15px;
  border:none;
  color:#25CEDE;
  font-size:16px;
  font-weight:500;
  letter-spacing:0.1px;
  min-width:346px;
`;

export const StyledReqElement = styled(Box)`
  display: flex;
  align-items: center;
  gap: 15px;
`;

type StyledReqTextType = {
  error?: boolean;
};
export const StyledReqText = styled(Typography)<StyledReqTextType>`
  // Later we might want to show different color if this condition is not matched
  // So it's 2 colors as of right now
  color: ${(props) => props.error ? '#98A2B3' : '#98A2B3'};
  transition: 0.2s color ease-out;
`;
